import React, { useContext } from 'react'
import { LanguageContext } from '../LanguageSwitcher/LanguageContext'
import './NextSteps.scss'

/**
 * What happens after someone writes to us. The contact page asked for a
 * message without saying what it leads to; people hesitate when they cannot
 * picture the next step.
 */
const NextSteps = () => {
  const { translations: t } = useContext(LanguageContext)
  const steps = [1, 2, 3]

  return (
    <div className='next-steps'>
      <p className='next-steps-kicker'>{t.nextKicker}</p>
      <ol className='next-steps-list'>
        {steps.map((n) => (
          <li key={n}>
            <span className='next-steps-num'>{n}</span>
            <div>
              <h3>{t[`next${n}Title`]}</h3>
              <p>{t[`next${n}Text`]}</p>
            </div>
          </li>
        ))}
      </ol>
    </div>
  )
}

export default NextSteps
